module.exports = __webpack_public_path__ + "static/logo-firefox-fix-69214841a993b6e5ade109b95d3d3177.png";